import React, { useState, useEffect } from 'react';
import Navbar from '../../components/public/Navbar';
import Footer from '../../components/public/Footer';
import PageHeader from '../../components/public/PageHeader';
import CompanyOverview from '../../components/public/CompanyOverview';
import VisionMission from '../../components/public/VisionMission';
import Timeline from '../../components/public/Timeline';
import CoreValues from '../../components/public/CoreValues';
import TeamSection from '../../components/public/TeamSection';
import StatsSection from '../../components/public/StatsSection';
import CTASection from '../../components/public/CTASection';
import { publicApi } from '../../services/api';
import { parseSectionContent } from '../../utils/sectionContent';

const SECTION_COMPONENTS = {
  overview: CompanyOverview,
  vision_mission: VisionMission,
  timeline: Timeline,
  core_values: CoreValues,
  team: TeamSection,
  stats: StatsSection,
  cta: CTASection,
  content: ({ content }) => (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-green max-w-none">
        <div dangerouslySetInnerHTML={{ __html: content?.body || '' }} />
      </div>
    </section>
  ),
};

export default function AboutPage() {
  const [sections, setSections] = useState([]);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await publicApi.getPage('about');
      const data = res.data.data;
      setPage(data || null);
      setSections(data.sections || []);
    } catch (err) {
      setError('Gagal memuat data. Silakan coba lagi.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-light">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500">Memuat...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-bg-light">
        <div className="text-center bg-white p-8 rounded-2xl shadow-lg max-w-md">
          <span className="text-4xl mb-4 block">⚠️</span>
          <p className="text-red-600 mb-4">{error}</p>
          <button onClick={fetchData} className="bg-brand text-navy px-6 py-2 rounded-full hover:bg-brand-dark transition-colors font-semibold">Coba Lagi</button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navbar />
      <PageHeader title={page?.title || 'Tentang Kami'} subtitle="Mengenal lebih dekat Klinnovac" />
      {/* Dynamic Sections */}
      {sections.length > 0 ? (
        sections
          .filter(s => s.is_active)
          .sort((a, b) => a.order - b.order)
          .map((section) => {
            const Component = SECTION_COMPONENTS[section.type];
            if (!Component) return null;
            const parsedContent = parseSectionContent(section.content);
            return <Component key={section.id} content={parsedContent} />;
          })
      ) : (
        /* Fallback: render all default sections if no sections from API */
        <>
          <CompanyOverview content={{}} />
          <VisionMission content={{}} />
          <StatsSection content={{}} />
          <CoreValues content={{}} />
          <Timeline content={{}} />
          <TeamSection content={{}} />
          <CTASection content={{}} />
        </>
      )}
      <Footer />
    </div>
  );
}